import { scaleOrdinal } from 'd3-scale';
import { max } from 'd3-array';

import data from './data/data.json';
import {
  defaults, green, orange, red,
} from './utils/colors';

export default function (props) {
  const { initialWidth, initialHeight, isMobile } = props;

  const margins = {
    top: 0,
    right: 20,
    bottom: 20,
    left: 20,
  };

  const width = initialWidth - margins.right - margins.left;
  const height = initialHeight - margins.top - margins.bottom;

  const colorRange = [
    // '#670000', '#C52622', '#F18851', '#F8C153', '#F7D899',
    '#670000', '#c52622', '#E6655A', '#f89a8b', '#ffd3c3',
    defaults.invalid,
  ].flat();

  const textColorRange = [
    '#fff',
    '#fff',
    '#fff',
    '#111',
    '#111',
    '#111',
  ].flat();

  const categories = data.map(d => d.category)
    .filter((d, i, arr) => arr.indexOf(d) === i && d)
    .map(key => ({ key, value: data.filter(d => d.category === key).length }));

  const colorScale = scaleOrdinal()
    .domain(['Very high', 'High', 'Moderate', 'Low', 'Minimal', 'Not available'])
    .range(colorRange);

  const textColorScale = scaleOrdinal()
    .domain(['Very high', 'High', 'Moderate', 'Low', 'Minimal', 'Not available'])
    .range(textColorRange);

  const states = document.querySelector('#state-grid').textContent
    .split('\n')
    .map((line, index) => {
      const regex = /\w+/g;
      let m = null;
      const arr = [];

      // eslint-disable-next-line
			while (m = regex.exec(line)) {

        // eslint-disable-next-line
				const { category } = data.find(d => d.usps === m[0]);

        arr.push({
          key: m[0],
          selected: category !== '',
          category,
          x: m.index / 3,
          y: index,
        });
      }

      return arr;
    })
    .reduce((flat, next) => flat.concat(next), []);

  return {
    // categories
    colorScale,
    textColorScale,
    data: states,
    gridHeight: max(states, d => d.y),
    gridWidth: max(states, d => d.x),
    height,
    initialWidth,
    initialHeight,
    margins,
    width,
  };
}
